import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { hi as a, fi as h } from "./abstract-base-8edf0a84-e11d45a3.js";
import { i as l } from "./query-24926cff-3eb94bfb.js";
import { u as c } from "./utils-2e24a437-383bbd0f.js";
var m = Object.defineProperty,
  p = Object.getOwnPropertyDescriptor,
  f = function f(o, r, e, i) {
    for (var t = i > 1 ? void 0 : i ? p(r, e) : r, n = o.length - 1, s; n >= 0; n--) (s = o[n]) && (t = (i ? s(r, e, t) : s(t)) || t);
    return i && t && m(r, e, t), t;
  };
var u = /*#__PURE__*/function (_a) {
  _inherits(u, _a);
  function u() {
    var _this;
    _classCallCheck(this, u);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this)), c ? _this.internals = null : _this.internals = _this.attachInternals ? _this.attachInternals() : null;
    return _this;
  }
  _createClass(u, [{
    key: "setValidity",
    /**
     * Implement `ElementInternals.setValidity()` with default values.
     * @param flags Custom validation flags.
     * @param message Error message used in validation.
     * @param anchor Validation target to receive focus, typically the form control element used in the shadow DOM.
     */
    value: function setValidity(r, e) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.formAnchor;
      this.internals && this.internals.setValidity(r, e, i);
    }
  }], [{
    key: "formAssociated",
    get: function get() {
      return !0;
    }
  }]);
  return u;
}(a(h));
f([l(".form-anchor")], u.prototype, "formAnchor", 2);
export { u };